export default "__VITE_ASSET__CVpzx188__"